// dependencies
import { Map } from "immutable";

const initialState = Map({
	// This holds more information about the group
	// TODO - phase out departmentMap
	groupsMap: Map(),

	departmentMap: Map(),

	// holds a map of autocompletes
	queries: Map(),
});

export default function departments(state = initialState, action) {
	/*
        departmentMap: {
            departmentID : { _id, name }
        }
    */

	switch (action.type) {
		case "DEPARTMENTS:SET": {
			return state.setIn(["departmentMap"], action.departmentMap);
		}

		case "GROUPS:SETONE":
		case "DEPARTMENTS:SETONE": {
			return state.setIn(["departmentMap", action.groupID], action.groupObject);
		}

		case "DEPARTMENTS:SEARCH_PARSED": {
			return state.withMutations((mutable) => {
				mutable.setIn(["queries", action.query], action.groupList);
				mutable.get("departmentMap").merge(action.groupMap);
			});
		}

		case "GROUPS:FETCHONE@SUCCESS": {
			return state.setIn(["groupsMap", action.response.get("_id")], action.response);
		}

		default: {
			// never forget your default return state!
			return state;
		}
	}
}
